var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerShutterLevel24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.59 25h-40l5-6h39.82l-4.82 6zm4.81 4H20.59l-5 6h40l4.81-6zm1.74 10.28l-3.07-2.57L54.66 42H16v4h40.53l5.61-6.72zm0 10l-3.07-2.57L54.66 52H16v4h40.53l5.61-6.72z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_shutter_level_2-4.8701cace.svg";
export { SvgC1RollerShutterLevel24 as ReactComponent };